export var WEB_SDK_SOURCE = 'YandexTrustWebSDK';
export var PAN_SIZE = 16;
